import {
  PageableTableProvider,
  usePageableTable,
} from "../../../../context/PageableTableContext";
import { TableArtworkPrintingTechniqueRequest } from "../../components/ArtworkPrintingTechniquePagableTable";
import { useEffect, useMemo, useState } from "react";
import { TableArtworkCollectionRequest } from "../../components/ArtworkCollectionPagableTable";
import { useGetCollectionsHook } from "../../hooks/useGetCollectionsHook";
import { useGetPrintingTechniqueHook } from "../../hooks/useGetPrintingTechnique";
import { useArtworkApprovalContextStore } from "../../context/approvals/ArtworkApprovalsContext";
import { ArtworkApprovalActions } from "../../state/approvals";
import { ArtworkApprovalRequestTypes } from "../../state/approvals/data.type";
import { useGenericDebounce } from "../../../../hooks/useGenericDebounce";
import { ArtworkApprovalsFilterForm } from "../../components/approvals/filterForm";
import { ArtworkSearchFilterForm } from "../../components/search/filterForm";
import { TableArtworkCollectionSearch } from "../../components/ArtworkCollectionSearchPagableTable";
import {
  ArtworkPrintingTechniqueSearchResultsPagableTable
} from "../../components/ArtworkPrintingTechniqueSearchResultsPagableTable";
import { PageableTableActions } from "../../../../states/pageable-table";


export const SearchArtwork = () => {

  const {
    dispatch: dispatchPageTable,
  } = usePageableTable();


  const [artworkLevel, setArtworkLevel] = useState<
    "collection" | "printingTechnique"
  >("collection");

  const { state, dispatch } = useArtworkApprovalContextStore();

  const handleToggle = (newState: "collection" | "printingTechnique") => {
    setArtworkLevel(newState);
  };

  const { debounce } = useGenericDebounce(500);

  const habdleUpdateFilter = (key: any, value: any) => {
    if (artworkLevel === "collection") {
      debounce(
        dispatch,
        ArtworkApprovalActions.setStateValue(
          ArtworkApprovalRequestTypes.SET_COLLECTION_FILTERS,
          { ...state.collectionFilters, [key]: value },
        ),
      );
      return;
    }
    if (artworkLevel === "printingTechnique") {
      debounce(
        dispatch,
        ArtworkApprovalActions.setStateValue(
          ArtworkApprovalRequestTypes.SET_PRINTING_TECHNIQUE_FILTERS,
          { ...state.printingTechniqueFilters, [key]: value },
        ),
      );
      return;
    }
  };

  useEffect(() => {
    dispatchPageTable(PageableTableActions.setFirstRender(true));
    dispatchPageTable(PageableTableActions.setPageSize(50));
  }, [artworkLevel]);

  return (
    <>
      <div
        className="container-fluid mt-3 bg-white shadow py-3 rounded-1 d-flex flex-column justify-contnet-between h-100"
        style={{ minHeight: "70vh" }}
      >
        <h6 className="text-primary fw-bold card-header border-0 mb-2">
          Search Artwork
        </h6>

        <>
          <div className="d-flex justify-content-between table-top-container align-items-center">
            <ArtworkSearchFilterForm
              state={state.collectionFilters}
              onUpdateFilter={habdleUpdateFilter}
              onToggleArtworkLevel={handleToggle}
              artworkLevel={artworkLevel}
              isLoading={false}
            />
          </div>
            {artworkLevel === "collection" && <TableArtworkCollectionSearch />}
            {artworkLevel === "printingTechnique" && (
              <ArtworkPrintingTechniqueSearchResultsPagableTable />
            )}
        </>
      </div>
    </>
  );
};




